import React from 'react';
import { Skeleton } from '../ui/skeleton';

/**
 * Loading placeholder for GymCard.
 * Matches the large photo area (aspect-[2/1]) + name + location + rating layout.
 * Used during gym search (DirectoryPage) and while favourites load (FavouritesPage)
 * to fill the grid before results arrive.
 *
 * Lives under the canonical `src/components/` design-system root alongside the
 * `Skeleton` primitive it composes (see also blog/PostCardSkeleton).
 */
const GymCardSkeleton: React.FC = () => (
    <div aria-hidden="true" className="rounded-2xl border border-border-default bg-surface-base overflow-hidden">
        {/* Photo area */}
        <Skeleton className="w-full aspect-[2/1]" />
        {/* Info area */}
        <div className="p-3 h-[70px] flex flex-col justify-start">
            <Skeleton className="h-6 w-2/3 mb-0.5" />
            <div className="flex items-end justify-between mt-0.5">
                <Skeleton className="h-5 w-1/2" />
                <Skeleton className="h-5 w-16" />
            </div>
        </div>
    </div>
);

export default GymCardSkeleton;
